import type { FragmentOf } from "gql.tada";
import type {
	CardProductFragment,
	CardProductVariantFragment,
} from "~/components/product/ProductCard/ProductCard.fragments";
import { getVariantUrl } from "~/lib/links";
import { useStaticUrl } from "./static-url";

export const useVariantUrl = (
	product: FragmentOf<typeof CardProductFragment>,
	variant: FragmentOf<typeof CardProductVariantFragment>,
) => {
	const staticProductUrl = useStaticUrl("p/[slug]");
	return getVariantUrl(staticProductUrl, product, variant);
};
